import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Embed, factories, IEmbedConfiguration, models, service } from 'powerbi-client';
import { SnackbarStatus } from 'src/definitions/snackbar-status.enum';

import { ReportConfig } from '../../models/report-config';
import { CustomSnackbarService } from '../../services/custom-snackbar.service';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'app-report-embed',
  templateUrl: './report-embed.component.html',
  styleUrls: ['./report-embed.component.scss']
})
export class ReportEmbedComponent implements AfterViewInit {
  @Input() name? = '';

  constructor(public reportService: ReportService, private snackbarService: CustomSnackbarService) {}

  public embedReport?: Embed;

  /**
   * Connected with Power BI rendered event. Hides the default Power BI logo when toggled on
   */
  loading = true;

  @ViewChild('reportRef', { static: true, read: ElementRef }) reportRef?: ElementRef;

  /**
   * Retrieves report config after Angular has completed initialization of component's view
   * then, generates the embed report
   */
  ngAfterViewInit(): void {
    this.reportService.getConfig(this.name).subscribe((reportConfig: ReportConfig) => {
      this.generateEmbed(reportConfig);
    });
  }

  /**
   * Embed a PowerBI report with report config details
   * @param reportConfig - report powerBI config
   */
  generateEmbed(reportConfig: ReportConfig): void {
    this.loading = true;
    const powerBi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
    const embedConfiguration: IEmbedConfiguration = {
      type: 'report',
      tokenType: models.TokenType.Embed,
      accessToken: reportConfig.accessToken,
      embedUrl: reportConfig.embedUrl,
      id: reportConfig.reportId,
      pageView: 'fitToWidth',
      settings: {
        background: models.BackgroundType.Transparent,
        panes: {
          pageNavigation: {
            visible: false
          }
        }
      }
    };

    // If a datasetId is provided, use it on the report
    if (reportConfig.datasetId) {
      embedConfiguration.datasetBinding = { datasetId: reportConfig.datasetId };
    }

    this.embedReport = powerBi.embed(this.reportRef?.nativeElement, embedConfiguration);

    this.embedReport.on('error', (event: any) => {
      this.snackbarService.present(event.detail.message, SnackbarStatus.Error);
      this.loading = false;
    });

    this.embedReport.on('rendered', () => {
      this.loading = false;
    });
  }
}
